<template>
  <div>
    <div class="hy-cover-box">
      <img class="hy-cover-img" :src="$global.imgUrl + cover" alt="" />
      <img
        v-show="showType"
        class="hy-cover-type"
        :src="type | typeFilter"
        alt=""
      />
    </div>
    <div class="hy-content">
      <div v-if="isExtend" class="hy-extend">
        <span class="extend-text"
          >预计赚¥<span class="extend">{{ extendPrice }}</span></span
        >
        <span v-show="price && open == 1" class="extend-price">{{
          price
        }}</span>
      </div>
      <div v-else>
        <div v-show="price && open == 1" class="hy-price">
          <!-- <span class="hy-price-symbol">¥</span> -->
          <span class="hy-price-number">{{ price }}</span>
        </div>
      </div>
      <h5 class="hy-title" v-html="title"></h5>
      <div class="hy-info">
        <span v-html="address"></span>
        <span>{{ beginTime }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "title",
    "cover",
    "beginTime",
    "address",
    "type",
    "showType",
    "price",
    "open",
    "isExtend",
    "extendPrice",
  ],
  filters: {
    // 时间格式化
    typeFilter(type) {
      // 0未开始 1已开始 2已结束
      switch (type) {
        case 0:
          return require("@/assets/img//mobile-img/conference-not.png");
        case 1:
          return require("@/assets/img//mobile-img/conference-in.png");
        case 2:
          return require("@/assets/img//mobile-img/conference-end.png");
      }
    },
  },
  data() {
    return {
      searchStr: "",
    };
  },
  computed: {
    // highLightTitle() {
    //   return this.title.replaceAll(
    //     this.searchStr,
    //     `<span style="color:#517EF2">${this.searchStr}</span>`
    //   );
    // },
    // highLightAddress() {
    //   return this.address.replaceAll(
    //     this.searchStr,
    //     `<span style="color:#517EF2">${this.searchStr}</span>`
    //   );
    // },
  },
  created() {
    // this.searchStr = this.$route.query.paramStr;
  },

  methods: {},
};
</script>

<style scoped lang="scss">
.hy-cover-box {
  position: relative;
  width: 100%;
  height: 197px;
  .hy-cover-img {
    width: 100%;
    height: 100%;
  }
  .hy-cover-type {
    position: absolute;
    top: 0;
    right: 0;
    width: 45px;
    height: 20px;
  }
}
.hy-content {
  padding: 0 12px;
  .hy-extend {
    margin-top: 9px;
    .extend-text {
      margin-right: 10px;
      font-size: 12px;
      color: #ff3d3d;
      line-height: 17px;
      .extend {
        font-weight: 700;
        font-size: 16px;
      }
    }
    .extend-price {
      font-size: 12px;
      color: #999999;
      line-height: 17px;
    }
  }
  .hy-price {
    margin-top: 9px;
    .hy-price-symbol {
      font-size: 12px;
      color: #ff3d3d;
      line-height: 17px;
    }
    .hy-price-number {
      font-size: 16px;
      font-weight: 700;
      color: #ff3d3d;
      line-height: 17px;
    }
  }
  .hy-title {
    margin-top: 14px;
    font-size: 15px;
    color: #333333;
    line-height: 21px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .hy-info {
    margin-top: 12px;
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    color: #999999;
    line-height: 17px;
  }
}
</style>
